import http from '@/utils/http'

export default {
  url: 'auth/',
  login(data) {
    return http.post(`${this.url}web/login`, data)
  },
  logout() {
    return http.delete(`${this.url}logout`)
  },
  systemLogin(data) {
    return http.post(`${this.url}system/login`, data)
  },
  refreshToken() {
    return http.post(`${this.url}refresh`)
  },
  getImgCode() {
    return http.get(`code`)
  }
}
